import {
  Box,
  Button,
  CardMedia,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import MFSelectField from '../../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../components';
import { MFTextField } from '../../../lib/formik';
import {
  Formik,
  setNestedObjectValues,
  useFormikContext,
  validateYupSchema,
  yupToFormErrors,
  // useFormikContext,
} from 'formik';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import { Applicant } from '../../../redux-store/types/api-types';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_LISTING_STATUS,
  genderMasters,
  salutationsMasters,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  ONBOARDING_ID_TYPES_MASTER,
  isNaturalParent,
  relatedRelations,
  otherRelations,
  relatedRelations_xalt,
} from '../../../utils/constant';
import {
  getApplicantName,
  getApplicantType,
  getFirstHolderName,
  minDateForContributor,
  saveForLater,
  getRelation,
  applyRoleBasedStatus,
  applicationComparison,
  sendApplication_Nri,
  removeSingleQuote,
  folioValidationCheck,
  isIdTypeOutOfList,
  getStep,
  isOnboardingTypeMinor,
  preventSpecialCharacters,
  isFatherMother,
  IsInvestorWithPAN,
  ifPushToXalt,
} from '../../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { updateApplication } from '../../../redux-store/actions/application';
import { useHistory } from 'react-router';
import { DatePicker } from '../../../lib/formik/DatePicker';
import { ConfirmationDialog, CountryCodesDropDown } from '../../commonComponents';
import { contributorDetailsSchemaWithoutPan } from '../../../utils/schema';
import MFCheckbox from '../../../lib/formik/Checkbox';
import { Relations } from '../../../utils/constant';
import { getNationalityList } from '../../../redux-store/actions';
import { mdmsCountriesList, nationaliyType } from '../../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../../lib/formik/searchSelectField';
import FieldValidationNote from '../FieldValidationNote';
import UseRadioGroup from '../../../lib/formik/Radio';
import { nonDigitRegex } from '../../../utils/regex';
import { showError } from '../../../redux-store/actions/auth';

const contributorObject: Partial<Applicant> = {
  name: '',
  namePrefix: '',
  motherName: '',
  fatherOrSpouseName: '',
  dateOfBirth: minDateForContributor().toString(),
  status: 'Individual',
  nationality: '',
  taxIdNumber: '',
  relationShipWithFirstApplicant: '',
  mobile: '',
  gender: '',
  minorPan: '',
  minorDOB: null,
  minorName: '',
  minorFatherName: '',
  minorGender: '',
  minorMobile: '',
  minorCountryCode: '+91',
  minorCountryNameAndCode: 'India: +91',
  minorEmail: '',
  minorNamePrefix: 'Mr.',
  naturalParent: '',
  guardianRelationship: '',
  guardianRelationshipTypeOther: '',
  onboardingIdType: '',
  onboardingIdTypeOthers: '',
  panDeclaration: false,
  pan: '',
};
type updateApplicant = Applicant & {
  jointApplicantRelation: string | null;
};
export type Values = {
  modeOfHolding: string;
  applicants: Partial<updateApplicant>[];
  // poaHolderName: string;
  applicationSource: string;
  folio_no: string | null;
  saveType: string;
  nationalityDropdown: string[];
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  // poaHolderName: '',
  applicationSource: 'digitalonboarding',
  folio_no: '',
  saveType: 'save and proceed',
  nationalityDropdown: [],
};

const MinorContributorDetails = ({
  index,
  values,
}: {
  index: number;
  values: Values;
}): JSX.Element => {
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName(`applicants.${index}.minorMobile`);
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          label="ID Number"
          name={`applicants.${index}.minorPan`}
          placeholder="Enter ID Number"
          required
          autoComplete="off"
          inputProps={{ style: { textTransform: 'uppercase' } }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DatePicker
          label="Date of Birth *"
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'DD/MM/YYYY'}
          name={`applicants.${index}.minorDOB`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.minorName`}
          label="Full Name *"
          placeholder="Enter Full Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
              <MFSelectField
                name={`applicants.${index}.minorNamePrefix`}
                items={salutationsMasters.map((salutation) => ({
                  key: salutation,
                  value: salutation,
                }))}
                sx={{
                  color: 'primary.main',
                  '.MuiSvgIcon-root ': { color: 'primary.main' },
                  '&.MuiInputBase-root': {
                    '.MuiSelect-select': {
                      p: 0,
                      pr: 2.5,
                      border: 0,
                    },
                  },
                  '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
                }}
              />
            </InputAdornment>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.minorFatherName`}
          label="Father Name *"
          placeholder="Enter Father Name"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.minorGender`}
          label="Gender *"
          items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.minorEmail`}
          label="Email ID"
          placeholder="Enter Email ID"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          label="Mobile Number"
          name={`applicants.${index}.minorMobile`}
          placeholder="Enter Mobile number"
          onKeyDown={(e) => {
            preventSpecialCharacters(e);
          }}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name={`applicants.${index}.minorCountryNameAndCode`}
              value={values?.applicants[index]?.minorCountryNameAndCode || 'India: +91'}
            />
          }
          regexForFilterValue={nonDigitRegex}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.guardianRelationship`}
          label="Relationship with Guardian *"
          items={(!ifPushToXalt(application?.pushDataTo || '')
            ? relatedRelations
            : relatedRelations_xalt
          ).map((relation) => ({
            key: relation,
            value: relation,
          }))}
        />
      </Grid>
      {isFatherMother(values.applicants[index].guardianRelationship || '') && (
        <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }}>
          <UseRadioGroup
            formLabel="Natural Parents *"
            name={`applicants.${index}.naturalParent`}
            items={Object.keys(isNaturalParent).map((item) => ({
              label: isNaturalParent[item],
              value: item,
            }))}
            value={values.applicants[index].naturalParent?.toString()}
          />
        </Grid>
      )}
      {values?.applicants[index]?.guardianRelationship === 'OTHERS' && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.guardianRelationshipTypeOther`}
            label={`Please Specify Relationship *`}
            placeholder={`Enter Please Specify Relationship`}
          />
        </Grid>
      )}
    </>
  );
};

const HolderDetails = ({
  index,
  values,
  nationalitiesMdmsResponse,
  applicationStatus,
  ifXalt,
}: {
  index: number;
  values: Values;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  applicationStatus?: string;
  ifXalt: boolean;
}): JSX.Element => {
  const { setFieldValue } = useFormikContext();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  const [open, setOpen] = useState<{
    index: number;
    status: string;
  } | null>(null);

  const handleOpen = (index: number, status: string) => {
    setOpen({ index, status });
  };
  const handleClose = () => {
    setOpen(null);
  };
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.name`}
          label="Name *"
          placeholder="Enter Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
              <MFSelectField
                name={`applicants.${index}.namePrefix`}
                items={salutationsMasters.map((salutation) => ({
                  key: salutation,
                  value: salutation,
                }))}
                disabled={isFieldDisabled}
                sx={{
                  color: 'primary.main',
                  '.MuiSvgIcon-root ': { color: 'primary.main' },
                  '&.MuiInputBase-root': {
                    '.MuiSelect-select': {
                      p: 0,
                      pr: 2.5,
                      border: 0,
                    },
                  },
                  '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
                }}
              />
            </InputAdornment>
          }
          // onChange={({ target: { value } }) => {
          //   setFieldValue(`applicants.${index}.name`, value);
          //   index === 0 &&
          //     setFieldValue(
          //       'banks',
          //       values.banks.length
          //         ? values.banks.map((bank) => ({
          //             ...bank,
          //             pennydropCheck: false,
          //             pennydropVerified: false,
          //           }))
          //         : []
          //     );
          // }}
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.gender`}
          label="Gender *"
          items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.motherName`}
          label="Mother Name"
          placeholder="Enter Mother Name"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.fatherOrSpouseName`}
          label="Father/Spouse Name *"
          placeholder="Enter Father/Spouse Name"
          disabled={isFieldDisabled}
        />
      </Grid>
      {/* <Grid item xs={12} sm={6}>
        <MFTextField
          name="date-of-birth"
          label="Date of Birth *"
          placeholder="DD/MM/YYYY"
          startAdornment={
            <InputAdornment position="start">
              <CardMedia component="img" alt="Calender" src="images/calender.svg" />
            </InputAdornment>
          }
        />
      </Grid> */}
      <Grid item xs={12} sm={6}>
        <DatePicker
          label={'Date of birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of birth'}
          maxDate={minDateForContributor()}
          name={`applicants.${index}.dateOfBirth`}
          disabled={isFieldDisabled}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.status`}
          label="Status"
          placeholder="Enter Status"
          disabled={true}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SearchableSelect
          name={`applicants.${index}.nationality`}
          label="Country of Nationality of Applicant *"
          items={nationalitiesMdmsResponse
            // .filter((_nationality) => _nationality.nationality !== 'INDIAN')
            ?.map((nationality) => ({
              key: nationality?.name,
              value: nationality?.name,
            }))}
          disabled={isFieldDisabled}
          searchFieldPlaceholder={'Search Nationality'}
        />
        {/* <UseRadioGroup
          name={`applicants.${index}.nationality`}
          formLabel="Nationality of Applicant *"
          defaultValue="Indian"
          items={nationalitiesMasters
            .filter((_nationality) => {
              return values.applicants[index].status === 'NRI'
                ? _nationality !== 'Indian'
                : _nationality;
            })
            .map((_nationality) => ({
              label: _nationality,
              value: _nationality,
            }))}
          disabled={isFieldDisabled}
        /> */}
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.taxIdNumber`}
          label={`${
            values.applicants[index].onboardingIdType && values.applicants[index].onboardingIdType
              ? !isIdTypeOutOfList(values.applicants[index].onboardingIdType || '')
                ? ONBOARDING_ID_TYPES_MASTER[values.applicants[index].onboardingIdType || '']
                : values.applicants[index]?.onboardingIdTypeOthers
              : 'Id Number'
          }`}
          placeholder={`Enter ${
            values.applicants[index].onboardingIdType && values.applicants[index].onboardingIdType
              ? !isIdTypeOutOfList(values.applicants[index].onboardingIdType || '')
                ? ONBOARDING_ID_TYPES_MASTER[values.applicants[index].onboardingIdType || '']
                : values.applicants[index]?.onboardingIdTypeOthers
              : 'Id Number'
          }`}
          disabled={true}
        />
      </Grid>
      <Grid item xs={12}>
        <MFCheckbox
          name={`applicants.${index}.panDeclaration`}
          label="I, hereby declare that I do not hold a Permanent Account Number (PAN) card. I am making this declaration in accordance with the requirements of Form 49BA under Income Tax Rules for the purpose of investment in Fund.I understand that not having a PAN card necessitates the submission of Form 49BA by the Registered Intermediary to fulfill the regulatory requirements for the transaction in question. I undertake to provide all necessary details and supporting documents as required by the relevant authorities."
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
            alignItems: 'flex-start',
            '.MuiTypography-root': {
              fontSize: 15,
              fontWeight: 500,
            },
          }}
          checked={values.applicants[index].panDeclaration}
        />
      </Grid>
      {!values.applicants[index].panDeclaration && (
        <Grid item xs={12} md={6}>
          <MFTextField
            name={`applicants.${index}.pan`}
            label="PAN *"
            placeholder="Enter PAN"
            inputProps={{ style: { textTransform: 'uppercase' } }}
            onChange={(e) => {
              setFieldValue(`applicants.${index}.pan`, e.target?.value?.toUpperCase());
            }}
          />
        </Grid>
      )}

      {index !== 0 && (
        <Grid item xs={12} sm={6}>
          <MFSelectField
            name={`applicants.${index}.jointApplicantRelation`}
            label="Relationship With First Applicant *"
            items={(ifXalt ? Relations.concat(otherRelations) : Relations)
              .filter((relation) => {
                const { applicants } = values;
                const selectedRelations = applicants
                  .filter(
                    (_applicant, ind) =>
                      ind !== index &&
                      _applicant.jointApplicantRelation &&
                      ['Mother', 'Father', 'Spouse'].includes(_applicant.jointApplicantRelation)
                  )
                  .map((applicant) => applicant.jointApplicantRelation);
                return !selectedRelations.includes(relation);
              })
              .map((relation) => ({
                key: relation,
                value: relation,
              }))}
          />
          {values.applicants.map((applicant, idx: number) => {
            if (applicant.jointApplicantRelation === 'Others' && idx === index && !ifXalt) {
              return (
                <MFTextField
                  name={`applicants.${index}.relationShipWithFirstApplicant`}
                  label="Please Specify Relationship *"
                  placeholder={`Enter Relationship`}
                />
              );
            }
          })}
        </Grid>
      )}
      <ConfirmationDialog
        message={`Any change in the investor status will affect the application's status and workflow. Are you sure you want to proceed?`}
        open={open !== null}
        setOpen={handleClose}
        onSave={() => {
          setFieldValue(`applicants.${open?.index}.status`, open?.status);
          setFieldValue(`applicants.${open?.index}.nationality`, 'INDIAN');
          handleClose();
        }}
        onCancel={handleClose}
      />
      {/* <InfoDialog onClose={handleClose} open={open} content={'status changed to draft.'} /> */}
    </>
  );
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const [applicantToDelete, setApplicantToDelete] = useState<{
    index: number;
  } | null>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const { flowType = '' } = application || {};
  const ifXalt = ifPushToXalt(application?.pushDataTo || '');

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, [application]);

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const countryList = nationalitiesMdmsMasters.countries.concat(
          nationalitiesMdmsMasters.eddCountries
        );
        setMdmsCountriesList(countryList);
        const {
          applicants = [],
          modeOfHolding = '',
          applicationSource = 'digitalonboarding',
          folio_no = '',
        } = application || {};
        const sortedApplicants = applicants
          .map((applicant) => ({
            ...applicant,
            applicant_type: getApplicantType(applicant.applicant_type),
          }))
          .sort((applicant1, applicant2) => {
            return Number(applicant1.applicant_type) - Number(applicant2.applicant_type);
          });
        setContributorValues({
          ...contributorValues,
          folio_no: folio_no,
          applicationSource: applicationSource || 'digitalonboarding',
          modeOfHolding:
            modeOfHolding === 'joint'
              ? 'joint'
              : sortedApplicants.length > 1
              ? 'either or survivor'
              : modeOfHolding,
          applicants: applicants.length
            ? sortedApplicants.map((applicant) => ({
                ...applicant,
                status: applicant.status || 'Individual',
                namePrefix:
                  applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
                    ? applicant.namePrefix
                    : 'Mr.',
                jointApplicantRelation: ifXalt
                  ? applicant.relationShipWithFirstApplicant
                  : getRelation(applicant.relationShipWithFirstApplicant)
                  ? applicant.relationShipWithFirstApplicant
                  : 'Others',
                relationShipWithFirstApplicant: ifXalt
                  ? ''
                  : getRelation(applicant.relationShipWithFirstApplicant)
                  ? ''
                  : applicant.relationShipWithFirstApplicant,
                minorPan: applicant.minorPan || '',
                minorDOB: applicant.minorDOB || null,
                minorName: applicant.minorName || '',
                guardianRelationship:
                  ((!ifXalt ? relatedRelations : relatedRelations_xalt).includes(
                    applicant.guardianRelationship as string
                  )
                    ? applicant.guardianRelationship
                    : applicant.guardianRelationship
                    ? 'OTHERS'
                    : applicant.guardianRelationship) || '',
                guardianRelationshipTypeOther:
                  ((!ifXalt ? relatedRelations : relatedRelations_xalt).includes(
                    applicant.guardianRelationship as string
                  )
                    ? ''
                    : applicant.guardianRelationship) || '',
                minorFatherName: applicant.minorFatherName || '',
                naturalParent: applicant.naturalParent || '',
                minorGender: applicant.minorGender || '',
                minorMobile: applicant.minorMobile || '',
                minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
                minorEmail: applicant.minorEmail || '',
                minorNamePrefix: applicant.minorNamePrefix || 'Mr.',
                minorCountryCode: applicant.minorCountryCode || '+91',
                onboardingIdType: applicant.onboardingIdType,
                onboardingIdTypeOthers: applicant.onboardingIdTypeOthers,
                panDeclaration: applicant.panDeclaration ? applicant.panDeclaration : false,
              }))
            : [contributorObject],
          nationalityDropdown: countryList.map((list) => list?.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  // const validate = (values: Values): FormikErrors<Values> => {
  //   let errors: FormikErrors<Values> = {};
  //   const { applicants, poaHolderName } = values;
  //   if (applicants.length > 1 && !poaHolderName) {
  //     errors = { ...errors, poaHolderName: 'Please select POA' };
  //   }
  //   return errors;
  // };

  const handleApplicant = async (values: Values) => {
    const { applicants = [], modeOfHolding = '', saveType, folio_no, applicationSource } = values;
    const {
      id,
      currentStep,
      hasPOA,
      status,
      applicant1ReferenceId = '',
      applicationNumber,
    } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;

    const updatedApplicants = values.applicants.map((applicant) => {
      const { jointApplicantRelation, guardianRelationshipTypeOther, ...rest } = applicant;
      return {
        ...rest,
        // status,
        // addresses: addresses.length
        //   ? addresses.map((address) => {
        //       if (
        //         address.address_type === 'overseas' &&
        //         nationality.toLowerCase() === 'indian' &&
        //         applicantStatusMasters[status as string] === applicantStatusMasters.Individual
        //       ) {
        //         return { ...address, isActive: false };
        //       }
        //       return address;
        //     })
        //   : [],
        name: removeSingleQuote(applicant.name),
        fatherOrSpouseName: removeSingleQuote(applicant.fatherOrSpouseName),
        motherName: removeSingleQuote(applicant.motherName),
        relationShipWithFirstApplicant: ifXalt
          ? jointApplicantRelation
          : getRelation(jointApplicantRelation)
          ? jointApplicantRelation
          : removeSingleQuote(applicant.relationShipWithFirstApplicant),
        minorPan: removeSingleQuote(applicant.minorPan),
        minorName: removeSingleQuote(applicant.minorName),
        minorFatherName: removeSingleQuote(applicant.minorFatherName),
        naturalParent: isFatherMother(applicant.guardianRelationship || '')
          ? applicant.naturalParent
          : null,
        guardianRelationship: (applicant.guardianRelationship?.toUpperCase() === 'OTHERS'
          ? guardianRelationshipTypeOther
          : applicant.guardianRelationship) as string,
        minorCountryNameAndCode: applicant.minorCountryNameAndCode,
        minorCountryCode: applicant.minorCountryNameAndCode?.split(':')[1].trim(),
        pan: applicant.panDeclaration ? null : applicant.pan,
      };
    });
    const updatedModeOfHolding =
      applicants.filter((applicant) => applicant.isActive).length === 1 ? 'single' : modeOfHolding;
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        folio_no: folioValidationCheck(applicationSource as string) ? folio_no : '',
        applicationSource,
        applicants: updatedApplicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
        modeOfHolding: updatedModeOfHolding,
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );
    const isSaveLater = saveType !== 'save and proceed';
    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ...application!,
            applicants: updatedApplicants,
            modeOfHolding: updatedModeOfHolding,
            folio_no: folioValidationCheck(applicationSource as string) ? folio_no : '',
            applicationSource,
            ...(saveType === 'save and proceed' && {
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : (sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
                      APPLICATION_LISTING_STATUS[status as string] ===
                        APPLICATION_LISTING_STATUS.sent_to_applicant1) ||
                    (!sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
                      APPLICATION_LISTING_STATUS[status as string] ===
                        APPLICATION_LISTING_STATUS.sent_to_amc_approver)
                  ? 'draft'
                  : status,
            }),
            currentStep: getStep(2, isSaveLater),
            ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
            // !!currentStep && currentStep > 1
            //   ? applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //     ? 2
            //     : currentStep
            //   : applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
          flowType,
        })
      );
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      await handleApplicant(values);
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      onSubmit={handleSubmit}
      //validationSchema={contributorDetailsSchema}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            contributorDetailsSchemaWithoutPan(ifPushToXalt(application?.pushDataTo || '')),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit,
        values,
        setValues,
        validateForm,
        setErrors,
        setTouched,
        setFieldValue,
      }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            // columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {USER_ROLES.INVESTOR !== role && (
              <>
                {/* <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }} mb={2}>
                  <UseRadioGroup
                    formLabel="Application Source"
                    name="applicationSource"
                    defaultValue="digitalonboarding"
                    items={Object.keys(ApplicationSourceMaster).map((source) => ({
                      label: ApplicationSourceMaster[source],
                      value: source,
                    }))}
                    // disabled={true}
                  />
                </Grid> */}
                {folioValidationCheck(values.applicationSource) && (
                  <Grid item xs={12} sm={6} mb={2}>
                    <MFTextField
                      name={`folio_no`}
                      label={`Folio Number ${
                        folioValidationCheck(values.applicationSource) ? '*' : ''
                      }`}
                      placeholder="Enter Folio Number"
                      // disabled={isFieldDisabled}
                    />
                  </Grid>
                )}
              </>
            )}

            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Contributor details of{' '}
                  {isOnboardingTypeMinor(application?.onboardingType || '')
                    ? 'Guardian'
                    : `${getApplicantName(index + 1)} Applicant`}
                  {index !== 0 && (
                    <Box
                      sx={{ display: 'flex', alignItems: 'center' }}
                      onClick={() => setApplicantToDelete({ index })}>
                      <Typography
                        sx={{
                          color: 'rgba(196, 42, 51, 0.8)',
                          fontSize: 12,
                          ml: 'auto',
                          letterSpacing: '-0.2px',
                          cursor: 'pointer',
                        }}>
                        Remove Joint Holder{' '}
                      </Typography>
                      <IconButton sx={{ p: '2px' }}>
                        <CardMedia
                          component="img"
                          src="/images/delete-red.svg"
                          alt="Delete Icon"
                          sx={{ width: 'unset' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </SubHeading>
                <HolderDetails
                  index={index}
                  values={values}
                  nationalitiesMdmsResponse={mdmsCountriesList}
                  applicationStatus={application?.status}
                  ifXalt={ifXalt}
                />
                {isOnboardingTypeMinor(application?.onboardingType || '') && (
                  <>
                    <SubHeading
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      Contributor Details of Minor Applicant
                    </SubHeading>
                    <MinorContributorDetails index={index} values={values} />
                  </>
                )}
              </React.Fragment>
            ))}
            {!!values.applicants.length &&
              values.applicants.length < 3 &&
              ![USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) &&
              !isOnboardingTypeMinor(application?.onboardingType || '') && (
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      mt: 2,
                    }}
                    onClick={async () => {
                      const formErrors = await validateForm();
                      if (!Object.keys(formErrors).length) {
                        await handleApplicant(values);
                        history.push(
                          IsInvestorWithPAN(application?.flowType || '')
                            ? '/onboarding/enter-pan-number'
                            : '/onboarding/enter-tax-id-number',
                          {
                            redirectTo: '/application/contributor-details',
                            application,
                            firstHolderName: getFirstHolderName(values.applicants),
                            flowType: flowType,
                          }
                        );
                        return;
                      }
                      setTouched(setNestedObjectValues(formErrors, true));
                      setErrors(formErrors);
                    }}>
                    Add Joint Holder
                  </Button>
                </Grid>
              )}
            {values.applicants.length > 1 && (
              <>
                <SubHeading>Redeem </SubHeading>
                <Grid item xs={12}>
                  <MFCheckbox
                    checked={values.modeOfHolding === 'either or survivor'}
                    name="holding"
                    label="Either or Survivor"
                    onChange={({ target: { checked } }) => {
                      setFieldValue('modeOfHolding', checked ? 'either or survivor' : 'joint');
                      setOpen(checked ? false : true);
                    }}
                    disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
                  />
                </Grid>
                {/* {values.modeOfHolding !== 'joint' && (
                  <>
                    <SubHeading>POA</SubHeading>
                    <Grid item xs={12}>
                      <UseRadioGroup
                        formLabel=""
                        name="poaHolderName"
                        items={values.applicants.map((applicant, index) => ({
                          label: applicant.name || `Applicant ${index + 1}`,
                          value: applicant.name || `Applicant ${index + 1}`,
                        }))}
                      />
                    </Grid>
                  </>
                )} */}
              </>
            )}
            <FieldValidationNote />
            <ProceedSaveLater
              goToPreviousStep={() => {
                history.push('distributor-details');
              }}
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                    relationShipWithFirstApplicant: ifXalt
                      ? applicant.jointApplicantRelation
                      : applicant.jointApplicantRelation === 'Others'
                      ? applicant.relationShipWithFirstApplicant
                      : applicant.jointApplicantRelation,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                    relationShipWithFirstApplicant: ifXalt
                      ? applicant.jointApplicantRelation
                      : applicant.jointApplicantRelation === 'Others'
                      ? applicant.relationShipWithFirstApplicant
                      : applicant.jointApplicantRelation,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                p: 4,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ mb: 2 }}>
              <CardMedia
                component="img"
                src="/images/warning-icon-red.svg"
                sx={{ width: 'unset', mx: 'auto' }}
              />
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: 'center',
                },
              }}>
              <Typography sx={{ color: '#FD3A69', lineHeight: '35px' }}>
                Disabling “Either or Survivor” will cause issues later.
              </Typography>
              <Typography sx={{ color: 'primary.main', lineHeight: '35px' }}>
                Are you willing to disable?
              </Typography>
            </Box>
            <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
              <Button
                onClick={() => {
                  setValues({
                    ...values,
                    modeOfHolding: 'joint',
                  });
                  handleClose();
                }}
                variant="outlined"
                sx={{
                  fontSize: 14,
                  color: 'primary.main',
                  minWidth: 200,
                }}>
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setValues({
                    ...values,
                    modeOfHolding: 'either or survivor',
                  });
                  handleClose();
                }}
                sx={{
                  fontSize: 14,
                  minWidth: 200,
                }}>
                No
              </Button>
            </Grid>
          </Dialog>
          <ConfirmationDialog
            message={`Are you sure you want to delete applicant ?`}
            open={applicantToDelete !== null}
            setOpen={() => setApplicantToDelete(null)}
            onSave={async () => {
              try {
                const remainedApplicants = values.applicants.map((applicant, i) => {
                  const noOfApplicants = values.applicants.length;
                  if (i === applicantToDelete?.index) {
                    return {
                      ...applicant,
                      isActive: false,
                    };
                  }
                  if (noOfApplicants === 3 && i === 2) {
                    return {
                      ...applicant,
                      applicant_type: '2',
                    };
                  }
                  return applicant;
                });
                const defaultPayload = {
                  applicants: remainedApplicants.map((applicant) => {
                    const { jointApplicantRelation, ...rest } = applicant;
                    return {
                      ...rest,
                      relationShipWithFirstApplicant: ifXalt
                        ? jointApplicantRelation
                        : getRelation(jointApplicantRelation)
                        ? jointApplicantRelation
                        : applicant.relationShipWithFirstApplicant,
                    };
                  }),
                  modeOfHolding:
                    remainedApplicants.filter((applicant) => applicant.isActive).length === 1
                      ? 'single'
                      : values.modeOfHolding,
                };
                if (application?.id) {
                  setApplicantToDelete(null);
                  await dispatch(
                    updateApplication({
                      body: {
                        ...application,
                        ...defaultPayload,
                        currentStep: 1,
                        status:
                          !application?.hasPOA &&
                          AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                          application?.status !== 'draft' &&
                          applyRoleBasedStatus(role)
                            ? 'sent_to_amc_approver'
                            : application?.status,
                      },
                      applicationId: application.id,
                      flowType,
                    })
                  );
                }
              } catch (error) {
                typeof error === 'string' && dispatch(showError(error));
                console.error((error as Error).message);
              }
            }}
            onCancel={() => setApplicantToDelete(null)}
          />
        </>
      )}
    </Formik>
  );
}
